// Thin wrapper around gtag. Safe no-op when GA hasn't loaded (dev/SSR/blocked).
const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export const trackEvent = (name, params = {}) => {
  if (!hasGtag()) return;
  try {
    window.gtag('event', name, params);
  } catch (e) {
    // Never let analytics break the app.
  }
};

// GA4 recommended e-commerce events
export const trackViewItem = (product) => {
  trackEvent('view_item', {
    currency: 'INR',
    value: product.pricePerStem,
    items: [{
      item_id: product.id,
      item_name: product.name,
      item_variant: product.variety,
      price: product.pricePerStem,
      quantity: 1,
    }],
  });
};

export const trackAddToCart = (product, orderType, quantity, price) => {
  trackEvent('add_to_cart', {
    currency: 'INR',
    value: price * quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      item_variant: orderType,
      price,
      quantity,
    }],
  });
};

export const trackBeginCheckout = (cart, totalAmount) => {
  trackEvent('begin_checkout', {
    currency: 'INR',
    value: totalAmount,
    items: cart.map(item => ({
      item_id: item.productId,
      item_name: item.name,
      item_variant: item.orderType,
      price: item.price,
      quantity: item.quantity,
    })),
  });
};

export const trackPurchase = (order) => {
  trackEvent('purchase', {
    transaction_id: order.id,
    currency: 'INR',
    value: order.totalAmount,
    items: (order.items || []).map(item => ({
      item_id: item.productId,
      item_name: item.productId, // productId; name may not be on order.items
      item_variant: item.orderType,
      price: item.price,
      quantity: item.quantity,
    })),
  });
};

export const trackExitIntent = (reason) => {
  trackEvent('exit_intent_feedback', { reason });
};
